// Captured pieces, one row per side that lost them. The color of a piece says whose it was.

import type { Owner, Piece } from '../engine/types';
import type { GameState } from '../game/state';
import { el } from '../lib/dom';
import { svg } from '../lib/svg';
import { subscribeView, viewedGame } from '../state/view';
import { createMiniGlyph, GLYPH_BOX } from './PieceGlyph';

const ROWS: readonly Owner[] = ['gold', 'violet', 'neutral'];

const miniSvg = (piece: Piece): SVGSVGElement =>
  svg(
    'svg',
    {
      class: 'graveyard__piece',
      viewBox: `0 0 ${GLYPH_BOX} ${GLYPH_BOX}`,
      // A piece keeps its size when its box gets narrow, so a crowded row overlaps.
      preserveAspectRatio: 'xMinYMid slice',
    },
    [createMiniGlyph(piece.kind, piece.owner)],
  );

/** `owners` are the sides whose lost pieces show. A team sheet shows the pieces its side took. */
export const createGraveyard = (owners: readonly Owner[] = ROWS): HTMLElement => {
  const rows = new Map(
    owners.map((owner) => [
      owner,
      el('div', { className: `graveyard__row graveyard__row--${owner}` }),
    ]),
  );
  const root = el('div', { className: 'graveyard' }, [...rows.values()]);

  const draw = (state: GameState): void => {
    for (const [owner, row] of rows) {
      const lost = state.captured.filter((piece) => piece.owner === owner);
      row.replaceChildren(...lost.map(miniSvg));
      row.hidden = lost.length === 0;
    }
  };

  draw(viewedGame());
  subscribeView(() => draw(viewedGame()));
  return root;
};
